export const thursdayAbbreviatedLowercase = "efIG$c";
export default {thursdayAbbreviatedLowercase};